import React from 'react'
import './MobileMenu.css'
import { motion, AnimatePresence } from 'framer-motion'

export default function MobileMenu() {
  return (
    <AnimatePresence>
      <motion.article 
        initial={{scale: .4}}
        animate={{scale: 1}}
        transition={{duration: .2, ease: "easeInOut"}}
        className="nav-mobile">
          <button type="button" className='link'>Features</button>
          <button type="button" className='link'>Pricing</button>
          <button type="button" className='link'>Ressources</button>
          <hr/>
          <button type="button" className='link'>Login</button>
          <button type="button" className="green-btn">Sign Up</button>
      </motion.article>
    </AnimatePresence>
  )
}
